import { request, Response } from '../utils';
import { Session } from '../types';

export const deleteFile = (body: {
  session: Session;
  contentHash: string;
}): Response<null> => request('delete-file', body);
